import React from 'react';
import PropTypes from 'prop-types';
import { SearchForm } from './SearchForm';
import { FieldGroup } from './FieldGroup';
import { FormControl } from './Controls/FormControl';
import { FAIcon } from '../fa-icon';
import classNames from 'classnames';

export const SearchComponent = props => {
  const {
    disabled,
    name = 'searchValue',
    searchAction,
    valueChangeDelay,
    wrapperClass,
    value,
    ...controlProps
  } = props;
  const inputProps = { ...controlProps, className: classNames('ui-default', 'regular', controlProps?.className) };
  const wrapperClasses = classNames('search-wrapper', wrapperClass, { disabled });

  return (
    <SearchForm
      className={wrapperClasses}
      searchAction={searchAction}
      valueChangeDelay={valueChangeDelay}
      defaultValues={{ searchValue: value }}
    >
      <div className="search-icon">
        <FAIcon icon="search" />
      </div>
      <FieldGroup className="search-input">
        <FormControl name={name} disableSubmit={true} disabled={disabled} {...inputProps} />
      </FieldGroup>
    </SearchForm>
  );
};

SearchComponent.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  searchAction: PropTypes.func.isRequired,
  value: PropTypes.object,
  valueChangeDelay: PropTypes.number,
  wrapperClass: PropTypes.string,
  placeholder: PropTypes.string,
};
